import { gql } from '@apollo/client';

export const AUDIT_LOGS_QUERY = gql`
  query AuditLogs(
    $filters: AuditLogFilterInput
    $sort: AuditLogSortInput
    $pagination: AuditLogPaginationInput
  ) {
    auditLogs(filters: $filters, sort: $sort, pagination: $pagination) {
      items {
        _id
        accountId
        teamId
        teamName
        userId
        type
        action
        text
        itemId
        sourceDomain
        ipAddress
        createdAt
        description
        actorName
        actorEmail
        isSupport
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;
